import { ReactElement } from 'react';
import parse from 'html-react-parser';
import cn from 'classnames';

import styles from './Label.module.scss';

import { Tooltip } from '../Tooltip/Tooltip';
import { useKeyboardClick } from '../../hooks/useKeyboardClick';

interface LabelProps {
    children: string;
    htmlFor?: string;
    description?: string;
    className?: string;
    help?: string;
    onClick?: () => void;
    onHelpClick?: () => void;
}

export const Label = ({
    children,
    htmlFor,
    description,
    className,
    onClick,
    help,
    onHelpClick,
}: LabelProps): ReactElement | null => {
    const handleHelpKey = useKeyboardClick(() => {
        if (onHelpClick) {
            onHelpClick();
        }
    });

    return (
        <label
            className={cn(styles.wrapper, className)}
            onClick={onClick}
            htmlFor={htmlFor}
        >
            {parse(children)}

            {help && <Tooltip className={styles.tooltip} text={help} />}

            {onHelpClick && (
                <div
                    tabIndex={0}
                    className={cn(styles.help, 'help')}
                    onClick={onHelpClick}
                    onKeyDown={handleHelpKey}
                    aria-label="Nápověda"
                >
                    ?
                </div>
            )}

            {description && <p className={styles.description}>{description}</p>}
        </label>
    );
};
